import { createContext, useContext } from 'react';

export type SymbolContextState = {
  sendEmoji: (emoji: string) => void;
  sendSticker: (url: string) => void;
  toggleManagement: (value?: boolean) => void;
};

export const SymbolContext = createContext<SymbolContextState>({} as SymbolContextState);

export const SymbolContextProvider = SymbolContext.Provider;

export const useSymbolContext = () => useContext(SymbolContext);
